import React, { useEffect } from 'react';
import { Tabs } from 'antd';
import { useFlags } from '@/contexts/Flags';
import { useTopTitle } from '@/contexts/TopTitle';
import { InvoicesTab } from './_components/InvoicesTab';
import { ChargesTab } from './_components/ChargesTab';
import * as S from './styled';

const Invoice = () => {
    const { titleValue } = useTopTitle();
    const flags = useFlags();

    useEffect(() => {
        titleValue('Boletos e cobranças');
    }, []);

    const items = [
        { key: 'invoices', label: 'Boletos', children: <InvoicesTab /> },
        ...(flags?.CHARGE
            ? [
                  {
                      key: 'charges',
                      label: 'Cobranças',
                      children: <ChargesTab />,
                  },
              ]
            : []),
    ];

    return (
        <S.Container>
            <S.TabsArea>
                <Tabs defaultActiveKey="invoices" items={items} />
            </S.TabsArea>
        </S.Container>
    );
};

export default Invoice;
